/**
 * External dependencies
 */
import axios from "axios";

/**
 * WordPress dependencies
 */
import { __, _n, sprintf } from "@wordpress/i18n";

/* global navigator */

const {
	NinetyNineData: { ajaxurl, searchLocationsNonce },
} = window;

export const getCoordinates = () =>
	new Promise((resolve, reject) =>
		navigator.geolocation.getCurrentPosition(resolve, reject)
	);

export const loadLocationsByAddress = async address =>
	await axios({
		method: "post",
		url: ajaxurl,
		params: {
			action: "nnr_search_locations_by_address",
			_wpnonce: searchLocationsNonce,
			address,
		},
	});

export const loadLocationsByLatLng = async ({ lat, lng }) =>
	await axios({
		method: "post",
		url: ajaxurl,
		params: {
			action: "nnr_search_locations_by_lat_lng",
			_wpnonce: searchLocationsNonce,
			lat,
			lng,
		},
	});

const counters = {};

export const createLocationRadio = ({
	location,
	context,
	mapLink = true,
	name = "location",
	required = false,
}) => {
	if (undefined === counters[context]) {
		counters[context] = 1;
	}

	const id = `location-${counters[context]}`;
	const wrap = document.createElement("div");
	wrap.classList.add("radio-item");

	const input = document.createElement("input");
	input.setAttribute("type", "radio");
	input.setAttribute("id", id);
	input.setAttribute("name", name);
	input.setAttribute("value", location.store_code);

	if (true === required) {
		input.required = true;
	}

	const label = document.createElement("label");
	label.innerText = location.address;
	label.setAttribute("for", id);
	label.classList.add("is-style-p2");

	if (true === mapLink) {
		const link = document.createElement("a");
		link.innerText = __("Map", "ocharleys");
		link.setAttribute("target", "_blank");
		link.setAttribute(
			"href",
			`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
				location.address
			)}`
		);

		label.appendChild(link);
	} else {
		const distance = document.createElement("span");
		distance.innerText = sprintf(
			__("%s mi. from you", "ocharleys"),
			location.distance_miles
		);

		label.innerText += " ";
		label.appendChild(distance);
	}

	wrap.appendChild(input);
	wrap.appendChild(label);

	counters[context]++;

	return wrap;
};

export const getLocationsHeading = count =>
	sprintf(
		_n("%s location found.", "%s locations found.", count, "ocharleys"),
		count
	);
